/** The meter an organization's usage is counted in (AIT-436). */
export type UsageUnit = 'messages' | 'actions';

/** Title-cased meter name, for headings, card titles, and column headers. */
export function unitTitle(unit: UsageUnit | undefined): 'Actions' | 'Messages' {
  return unit === 'actions' ? 'Actions' : 'Messages';
}

/**
 * Lower-cased meter name, for prose and aria labels.
 *
 * Defaults to the legacy meter when the field is missing: an older payload
 * with no `usageUnit` came from a message-metered org, and that is the only
 * safe reading of its absence.
 */
export function unitLabel(unit: UsageUnit | undefined): UsageUnit {
  return unit === 'actions' ? 'actions' : 'messages';
}

/** Meter name agreeing in number with `count`: "1 action", "2 actions". */
export function singularUnit(unit: UsageUnit | undefined, count: number): string {
  const plural = unitLabel(unit);
  return count === 1 ? plural.slice(0, -1) : plural;
}
